import { Check, X, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import { COMPARISON, BRAND } from "@/data/content";
import { useQuote } from "@/context/QuoteContext";

const WhyChooseUs = () => {
  const { openQuote } = useQuote();
  return (
    <section className="py-24 md:py-32" data-testid="why-choose-us-section">
      <div className="max-shell mx-auto px-4 md:px-8 lg:px-12">
        <Reveal className="flex justify-center text-center">
          <SectionHeading
            eyebrow="Why Choose Us"
            title="The Global Eco Difference"
            subtitle="See how a professional, accountable solar partner compares to the typical local vendor."
            className="mx-auto"
          />
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14 grid md:grid-cols-2 gap-6">
            {/* Traditional */}
            <div className="rounded-3xl bg-white border border-slate-100 p-7 shadow-soft" data-testid="compare-traditional">
              <h3 className="text-lg font-bold text-slate-500">Traditional Solar Vendor</h3>
              <ul className="mt-6 space-y-4">
                {COMPARISON.map((c) => (
                  <li key={c} className="flex items-center gap-3 text-slate-400">
                    <span className="grid place-items-center h-6 w-6 rounded-full bg-slate-100">
                      <X className="h-3.5 w-3.5 text-slate-400" />
                    </span>
                    <span className="text-[15px] line-through">{c}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Global Eco */}
            <div className="relative rounded-3xl bg-brand-navy p-7 shadow-glass overflow-hidden" data-testid="compare-globaleco">
              <div className="absolute -top-10 -right-10 h-40 w-40 rounded-full bg-brand-green/20 blur-2xl" />
              <div className="relative flex items-center gap-2 text-brand-yellow">
                <Sun className="h-5 w-5" />
                <h3 className="text-lg font-bold text-white">{BRAND.name}</h3>
              </div>
              <ul className="mt-6 space-y-4">
                {COMPARISON.map((c) => (
                  <li key={c} className="flex items-center gap-3 text-white">
                    <span className="grid place-items-center h-6 w-6 rounded-full bg-brand-green">
                      <Check className="h-3.5 w-3.5 text-white" />
                    </span>
                    <span className="text-[15px] font-medium">{c}</span>
                  </li>
                ))}
              </ul>
              <Button
                onClick={() => openQuote("why-choose-us")}
                data-testid="why-cta"
                className="mt-8 w-full h-12 rounded-full bg-brand-yellow text-brand-navy font-semibold hover:bg-[#f0bd1f] hover:-translate-y-0.5 transition-transform"
              >
                Get Your Free Assessment
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default WhyChooseUs;
